import React, { Component } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  InputGroup,
  Row,
  Form,
} from "reactstrap";
import swal from "sweetalert2";

import LoadingButtonIcon from "@/views/Components/LoadingButtonIcon";
import authApi from "@/api/auth";
import { handleError } from "@/util/errorHandler";

class ForgotPassword extends Component {
  state = {
    email: "",
    isLoading: false,
    isEmailCorrect: true,
  };

  handleResetPassword = async event => {
    event.preventDefault();

    try {
      this.setState({ isLoading: true });

      const { login } = this.state;

      await authApi.resetPassword({
        login,
      });

      swal("Success", `The new password was send to your email`, "success");
      this.goBack();
    } catch (err) {
      handleError(err, { title: err.detail });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  goBack = () => {
    this.props.history.push("/login");
  };

  handleChangeEmail = ({ target: { value: login } }) => {
    this.setState({ login });
  };

  render() {
    return (
      <div
        className="app flex-row align-items-center"
        style={{
          backgroundColor: "#333131",
        }}>
        <Container>
          <Row className="justify-content-center">
            <Col lg="6" md="8">
              <Card
                className="p-4"
                style={{
                  borderColor: "#f2ecec",
                  borderWidth: 10,
                }}>
                <CardBody>
                  <h1>Forgot password</h1>
                  <Form onSubmit={this.handleResetPassword}>
                    <InputGroup className="mb-3">
                      <Input
                        type="text"
                        autoFocus
                        placeholder="Enter your login"
                        value={this.state.login}
                        invalid={!this.state.isEmailCorrect}
                        onChange={this.handleChangeEmail}
                        data-cy="login"
                      />
                    </InputGroup>
                    <Row className="justify-content-center mb-3">
                      <Button
                        type="submit"
                        color="primary"
                        className={this.state.isLoading ? "" : "px-4"}
                        disabled={this.state.isLoading || !this.state.login}
                        data-cy="submit">
                        <span>
                          Reset password
                          <LoadingButtonIcon loading={this.state.isLoading} />
                        </span>
                      </Button>
                    </Row>
                    <Row className="justify-content-center">
                      <Button
                        type="button"
                        className={"px-4"}
                        data-cy="back"
                        onClick={this.goBack}>
                        <span>Back</span>
                      </Button>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
              <p
                className="text-muted"
                style={{ marginTop: "16px", textAlign: "center" }}>
                {(() => {
                  const systemVersion = window.env && window.env.SYSTEM_VERSION;
                  const portalVersion = window.env && window.env.PORTAL_VERSION;
                  const parts = [];
                  if (systemVersion)
                    parts.push(`System version: ${systemVersion}`);
                  if (portalVersion)
                    parts.push(`Portal version: ${portalVersion}`);
                  return parts.length ? (
                    <>
                      {parts.join(" • ")}
                      <br />
                    </>
                  ) : null;
                })()}
                Email:{" "}
                <a target="_top" href="mailto:bakong@nbc.org.kh">
                  bakong@nbc.org.kh
                </a>
                <br />
                <a
                  target="_blank"
                  href="https://www.nbc.org.kh/download_files/bakong/Bakong_payment_gateway_user_manual.pdf"
                  rel="noopener noreferrer">
                  User manual
                </a>
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default ForgotPassword;
